import Vue from 'vue';

const RegInput = {
  inserted(el, binding, VNode) {
    let isComposing = false;
    const vNodeInstance = VNode.componentInstance;
    const isSetDefault = vNodeInstance && vNodeInstance.$attrs && vNodeInstance.$attrs.hasOwnProperty('is-set-default');

    Vue.nextTick(() => {
      // 找到真实可编辑的 input，排除 readonly
      const inputs = el.querySelectorAll('input.el-input__inner');
      let input;
      for (let i = inputs.length - 1; i >= 0; i--) {
        if (!inputs[i].hasAttribute('readonly')) {
          input = inputs[i];
          break;
        }
      }
      if (!input) return;

      input.addEventListener('compositionstart', () => {
        isComposing = true;
      });
      input.addEventListener('compositionend', () => {
        isComposing = false;
        handlerInput(isComposing, binding, input, isSetDefault);
      });
      input.addEventListener('input', () => {
        if (binding.arg === 'blank') return;
        handlerInput(isComposing, binding, input, isSetDefault);
      });
      input.addEventListener('blur', () => {
        if (binding.arg !== 'blank') return;
        const trimValue = input.value.replace(/^\s+|\s+$/g, '');
        if (trimValue !== input.value) {
          input.value = trimValue;
          input.dispatchEvent(new Event('input'));
        }
      });
    });
  },
};
function handlerInput(isComposing, binding, input, isSetDefault) {
  if (isComposing) return;

  let reg;
  switch (binding.arg) {
    case 'num': reg = /^\d*/; break;
    case 'point': reg = /^\d*(\.?\d{0,2})/; break;
    case 'pointOne': reg = /^\d*(\.?\d{0,1})/; break;
    case 'NAN': reg = /^[a-zA-Z_\u4e00-\u9fa5]*/; break;
    case 'spl': reg = /^[a-zA-Z0-9_\u4e00-\u9fa5]*/; break;
    case 'name': reg = /^[0-9_\u4e00-\u9fa5]*/; break;
    case 'noZh': reg = /^[a-zA-Z0-9]*/; break;
    case 'minus': reg = /^-?\d*/; break;
    case 'minusPoint': reg = /^-?\d*(\.?\d{0,2})/; break;
    case 'decimals': reg = /^\d*(\.?\d*)/; break;
    case 'blank': reg = /^\s+|\s+$/g; break;
    case 'numJust': reg = /^[1-9]\d*/; break;
    case 'zh': reg = /^[\u4e00-\u9fa5]*/; break;
    case 'numSpecial': reg = /^[0-9-*]*/; break;
    default: reg = /.*/;
  }

  try {
    let newValue;
    if (binding.arg === 'blank') {
      newValue = input.value.replace(reg, '');
    } else {
      const matchRes = input.value.match(reg);
      newValue = matchRes ? matchRes[0] : '';
      if (!newValue && isSetDefault) newValue = '1';
      if (binding.value) {
        newValue = newValue.substring(0, binding.value);
      }
    }

    // 只有当值真的改变时才触发 input
    if (newValue !== input.value) {
      input.value = newValue;
      input.dispatchEvent(new Event('input'));
    }
  } catch (e) {
    console.warn(e, 'RegInput handler error');
  }
}


export default RegInput;
